export default {
  masterChef: {
    4002: '',
    250: '0x9180583C1ab03587b545629dd60D2be0bf1DF4f2',
  },
  sousChef: {
    4002: '',
    250: '0x046d835d9db52E3F037617C93aa8aCEc0cd37c4c',
  },
  lottery: {
    4002: '',
    250: '0xBcA4819ab95a929e1b378687bd218d34D14F5f83',
  },
  lotteryNFT: {
    4002: '',
    250: '0x99d11EaF2f38777bb6062CB37f9528BFf9E6607E',
  },
  mulltiCall: {
    250: '0x3811badEd0eB029AA3D91ae0e861851503754da5',
    4002: '',
  },
  pancakeProfile: {
    250: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    4002: '',
  },
  pancakeRabbits: {
    250: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    4002: '',
  },
  bunnyFactory: {
    250: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    4002: '',
  },
  claimRefund: {
    250: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    4002: '',
  },
  pointCenterIfo: {
    250: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    4002: '',
  },
  bunnySpecial: {
    250: '0xFee8A195570a18461146F401d6033f5ab3380849',
    4002: '',
  },
  gfce: {
    250: '0x0DE624ED2882E7480d97b2bBee57675C4FA26e33',
    4002: '',
  },
}
